import { useQuery } from '@tanstack/react-query';
import api from '~/libs/api.ts';
import { getKvedPage } from './kvedPageableUtils.ts';

export { findKvedByOption, mapKvedsToAutocompleteOptions } from './kvedPageableUtils.ts';

export const useKvedPageableQuery = (search: string) => {
  const normalizedSearch = search.trim();
  const { data, isFetching } = useQuery({
    queryKey: ['kved', 'pageable', normalizedSearch],
    queryFn: () => getKvedPage(api, normalizedSearch),
    enabled: Boolean(normalizedSearch),
  });

  return {
    kveds: data?.content ?? [],
    isLoading: isFetching,
  };
};
